import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { setRestaurants, setRestaurant } from '../../redux/modules/restaurants';

export const MapContainer = (props) => {
  // REDUX
  const dispatch = useDispatch();
  const { restaurants } = useSelector((state) => state.restaurants);

  const [map, setMap] = useState(null);
  const { google, query, placeId } = props;

  // user query
  useEffect(() => {
    function searchByQuery(query) {
      const service = new google.maps.places.PlacesService(map);
      dispatch(setRestaurants([]));

      const request = {
        location: map.center,
        radius: '200',
        type: ['restaurant'],
        query,
      };

      service.textSearch(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          dispatch(setRestaurants(results));
        }
      });
    }
    if (query) {
      searchByQuery(query);
    }
  }, [
    query,
    dispatch,
    google.maps.places.PlacesService,
    google.maps.places.PlacesServiceStatus.OK,
    map,
  ]);

  // place id
  useEffect(() => {
    function getRestaurantById() {
      const service = new google.maps.places.PlacesService(map);
      dispatch(setRestaurant(null));

      const request = {
        placeId,
        fields: ['name', 'opening_hours', 'formatted_address', 'formatted_phone_number'],
      };

      service.getDetails(request, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          dispatch(setRestaurant(place));
        }
      });
    }
    if (placeId) {
      getRestaurantById(placeId);
    }
  }, [
    placeId,
    dispatch,
    google.maps.places.PlacesService,
    google.maps.places.PlacesServiceStatus.OK,
    map,
  ]);

  function searchNearby(map, center) {
    const service = new google.maps.places.PlacesService(map);
    dispatch(setRestaurants([]));

    const request = {
      location: center,
      radius: '2000',
      type: ['restaurant'],
    };

    service.nearbySearch(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        dispatch(setRestaurants(results));
      }
    });
  }

  function onMapReady(_, map) {
    setMap(map);
    searchNearby(map, map.center);
  }

  return (
    <Map
      google={google}
      centerAroundCurrentLocation
      onReady={onMapReady}
      onRecenter={onMapReady}
      {...props}>
      {restaurants.map((restaurant) => (
        <Marker
          key={restaurant.place_id}
          name={restaurant.name}
          position={{
            lat: restaurant.geometry.location.lat(),
            lng: restaurant.geometry.location.lng(),
          }}
        />
      ))}
    </Map>
  );
};

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
})(MapContainer);
